import type { ActivityDTO } from 'src/types/dto';

export function activityHasDependentActivities(
  activity: Pick<ActivityDTO, 'dependentActivities'> | null | undefined
): boolean {
  return (activity?.dependentActivities?.length ?? 0) > 0;
}
